import { useContext, useEffect, useRef, useState } from "react";
import { Context } from "../../context/Context";
import "./EquipmentsListModal.css";
import { CreateEquipments } from "../../api/api";
import SuccessToast from "../toasts/SuccessToast";
import { useNavigate, useParams } from "react-router-dom";

const EquipmentsNameModal = ({ equipment }) => {
  const {
    setEquipmentsNameModal,
    currentRoom,
    addedTypeEquipment,
    closeEquipmentListButton,
    setCloseEquipmentListButton,
    setRoomEquipments,
    roomEquipments,
    setIsLoading,
    setEquipments,
    setSelectedEquipment,
  } = useContext(Context);
  const [equipmentName, setEquipmentName] = useState("");
  const modalName = useRef(null);
  const closeButton = useRef(null);

  const { room_id: roomId } = useParams();

  const navigate = useNavigate();

  useEffect(() => {
    setEquipmentsNameModal(modalName);
  }, []);

  const handleRedirectEquipment = (equipment, roomId) => {
    if (!equipment) return navigate("/room/" + roomId);
    setSelectedEquipment({
      id: equipment.id,
      type: equipment.type,
    });
    if (equipment.type == 1) {
      return navigate(
        "/room/key/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 3) {
      return navigate(
        "/room/remote/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 4) {
      return navigate(
        "/room/dimmer/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 5) {
      return navigate(
        "/room/thermostat/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 9) {
      return navigate(
        "/room/rgb/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 99) {
      return navigate(
        "/room/wireless-key/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 100) {
      return navigate(
        "/room/television/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 501) {
      return navigate(
        "/room/fan-coil/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 401) {
      return navigate(
        "/room/scenario-key/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 503) {
      return navigate(
        "/room/humidity/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 502) {
      return navigate(
        "/room/motor/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 9998) {
      return navigate(
        "/room/input/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 9999) {
      return navigate(
        "/room/input-status/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 600) {
      return navigate(
        "/room/data-logger/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    }
  };

  const handleAddEquipment = () => {
    let room_id = roomId;
    let type = addedTypeEquipment;
    let name = equipmentName;
    setIsLoading(true);
    CreateEquipments({
      room_id,
      type,
      name,
    })
      .then(({ data }) => {
        SuccessToast("تجهیز با موفقیت افزوده شد");
        handleRedirectEquipment(data.equipment, data.room_equipment.room_id);
        setEquipments((prev) => [...prev, data.room_equipment]);
        setEquipmentName("");
        closeEquipmentListButton.current.click();
        closeButton.current.click();
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    // Modal
    <div
      className="modal fade"
      id="equipmentsName"
      tabIndex="-1"
      aria-labelledby="equipmentsNameLable"
      aria-hidden="true"
      ref={modalName}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="equipmentsNameLable">
              انتخاب نام تجهیز
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref={closeButton}
            ></button>
          </div>
          <div className="modal-body">
            <div className="mb-3">
              <label htmlFor="equipmentName" className="form-label">
                نام تجهیز را وارد کنید
              </label>
              <input
                type="text"
                className="form-control"
                id="equipmentName"
                value={equipmentName}
                onChange={(e) => setEquipmentName(e.target.value)}
              />
            </div>
            <div>
              {/* <button
                type="button"
                className="btn btn-success-app mb-2"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                انصراف
              </button> */}
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-success-app me-3 mb-2"
              onClick={handleAddEquipment}
            >
              تایید
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EquipmentsNameModal;
